(function($) {

	"use strict";

/** --------------------------------------------------
 *
 *   CHECKOUT
 *
 *   TABLE OF CONTENTS
 *	 document ready
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {
		if( $('body').hasClass('path-checkout') ) {

			$('.form-disabled').each(function(){
				$(this).find('input, select').wrap("<div class='custom-input-error-wrapper'></div>");
			});

			/* "go to payment" button */
			/* ********************** */

			/* add a loader when clicked - because
			 * the payment page can take some time to load
			 */

			$(document).on('click', '.commerce-checkout-flow .form-submit .js-loader', function(e) {

				// prevent the form submit:
				e.preventDefault();

				// add a loading-class:
				$('body').addClass('js-page-loading');

				// add extra markup for a loader-icon:
				$('body').append('<div class="ajax-progress-fullscreen">' + Drupal.t('Loading') + '</div>');

				// submit the form:
			 	setTimeout(function(){
					$('form.commerce-checkout-flow-multistep-default').submit();
				}, 100);

			});

		}
	});




})(jQuery);
